import { yupResolver } from "@hookform/resolvers/yup";
import { Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";

import { FormContainer } from "../../layout";
import { FormSubmitButton, FormTextField } from "../../form-components";
import { useAuth } from "../../../contexts/AuthContext";

interface CompletePassword {
  password: string;
  passwordConfirmation: string;
}

const schema = yup.object().shape({
  password: yup.string().required().label("New Password"),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match"),
});

export const CompletePasswordForm = () => {
  const { completeNewPassword } = useAuth();
  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<CompletePassword>({
    resolver: yupResolver(schema),
  });

  return (
    <FormContainer
      onSubmit={handleSubmit(async (login) => {
        completeNewPassword(login.password).then(() => navigate("/"));
        localStorage.removeItem("authState");
      })}
    >
      <Stack direction="column" spacing={2}>
        <FormTextField
          name="password"
          label="Password"
          control={control}
          required
          type="password"
        />
        <FormTextField
          name="passwordConfirmation"
          label="Confirm Password"
          control={control}
          required
          type="password"
        />
      </Stack>
      <FormSubmitButton disabled={isSubmitting} />
    </FormContainer>
  );
};
